import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'chevron-compact-down',
  'IconChevronCompactDown',
  [['path', { d: 'M4 11l8 3l8 -3', key: 'svg-0' }]],
);
